// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2gtgB","container":"styles_container__31Jt2","title":"styles_title__18DTV","wrapper":"styles_wrapper__2eLMz","answer":"styles_answer__8lr1P"};